// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1Yrvj","buttons":"RemoveExpirationActionButtons_buttons__2UNEI"};